import React, { useState, useEffect } from "react";
import axios from "axios";
import VideoLoader from "./VideoLoader";
import ProgressBar from "./ProgressBar";
import styles from "../style/components/VideoUploadForm.module.css";
import { v4 as uuidv4 } from "uuid";

const VideoUploadForm = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [video, setVideo] = useState(null);
  const [trailer, setTrailer] = useState(null);
  const [poster, setPoster] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [progress, setProgress] = useState(0);
  const [progressId, setProgressId] = useState("123");
  const [uploadStage, setUploadStage] = useState("");
  const [logs, setLogs] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !description || !price || !video || !trailer || !poster) {
      return setMessage("Пожалуйста, заполните все поля и выберите файлы.");
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("price", price);
    formData.append("video", video);
    formData.append("trailer", trailer);
    formData.append("poster", poster);

    try {
      setLoading(true);
      const res = await axios.post(
        "https://rishat-tour.ru/api/videos",
        formData,
        {
          timeout: 5 * 10 * 60 * 1000,
          headers: {
            "Content-Type": "multipart/form-data",
            "x-progress-id": progressId,
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percent);
          },
        }
      );

      setMessage("Видео успешно загружено!");
      setTitle("");
      setDescription("");
      setPrice("");
      setVideo(null);
      setTrailer(null);
      setPoster(null);
    } catch (error) {
      console.error(error);
      setMessage("Ошибка загрузки видео.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const res = await axios.get("https://rishat-tour.ru/api/logs");
        setLogs(res.data);
      } catch (err) {
        console.error("Ошибка получения логов:", err);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const newId = uuidv4();
    setProgressId(newId);

    const source = new EventSource(
      `https://rishat-tour.ru/api/upload-progress?id=${newId}`
    );
    source.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.step === "uploading_to_cloud")
        setUploadStage("Загрузка в облако...");
      else if (data.step === "analyzing_video")
        setUploadStage("Обработка видео...");
      else if (data.step === "done") {
        setUploadStage("Готово!");
        source.close();
      }
      if (data.error) {
        setUploadStage("Ошибка: " + data.error);
        source.close();
      }
    };

    return () => {
      source.close();
    };
  }, []);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Загрузка видео</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          type="text"
          placeholder="Название видео"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className={styles.input}
        />
        <textarea
          placeholder="Описание"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className={styles.textarea}
        />
        <input
          type="number"
          placeholder="Цена (в рублях)"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          className={styles.input}
        />

        <label className={styles.label}>Видео (.mp4, .mov)</label>
        <input
          type="file"
          accept="video/mp4, video/quicktime"
          onChange={(e) => setVideo(e.target.files[0])}
          className={styles.fileInput}
        />

        <label className={styles.label}>Трейлер (.mp4, .mov)</label>
        <input
          type="file"
          accept="video/mp4, video/quicktime"
          onChange={(e) => setTrailer(e.target.files[0])}
          className={styles.fileInput}
        />

        <label className={styles.label}>Постер (размер 3/1.5)</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setPoster(e.target.files[0])}
          className={styles.fileInput}
        />

        {loading && <ProgressBar progress={progress} />}
        {uploadStage && <p className={styles.stage}>{uploadStage}</p>}

        <button type="submit" disabled={loading} className={styles.button}>
          {loading ? (
            <div className={styles.loaderWrapper}>
              <span className={styles.spinner} />
              <span>Загрузка...</span>
            </div>
          ) : (
            "Загрузить"
          )}
        </button>

        {logs.length > 0 && loading && (
          <span>
            <p>Загрузка видео на Яндекс!</p>
            {logs[logs.length - 1].split("]")[1].toString()}
          </span>
        )}

        {message && <p className={styles.message}>{message}</p>}
      </form>
    </div>
  );
};

export default VideoUploadForm;
